<template>
  <p class="text-16 text-navy mb-0">
    <time :datetime="date">
      <slot />
    </time>
  </p>
</template>

<script>
export default {
  props: {
    date: {
      type: String,
      required: true,
    },
  },
};
</script>
